import { Injectable } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { environment } from "src/environments/environment";
import { CommonsService } from "./commons.service";
import { MessagesService } from "./messages.service";
import DataSource from "devextreme/data/data_source";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Status } from "src/api/generated";
import { TranslateWithFallbackPipe } from "acl-cloud-lib";

@Injectable({
  providedIn: 'root'
})
export class StatusService {
  private _baseUrl: string = environment.baseUrl + "/Status";
  public dataSource: DataSource<Status, string>;

  constructor(
    private _commonSvc: CommonsService,
    private _http: HttpClient,
    private _spinner: NgxSpinnerService,
    private _msgSvc: MessagesService,
    private _translate: TranslateWithFallbackPipe
  ) {
    this.dataSource = this._commonSvc.makeAsyncDataSource<Status, string>(undefined, undefined);
    // this.dataSource = _commonSvc.makeAsyncDataSource<Status, string>(this._baseUrl, "list", "one", "distinct_values", undefined); OLD
    // Pokial bude hotove BE tak je potrebne pregenerovat services a nastavyt tu podla ostatnych servisu ktora bude vsetko volat tak ako ma
  }

  public SaveStatus(status: Status): void {
    this._spinner.show();

    // If be BE is ready, this will be changed to generated service
    this._http.post<Status>(`${this._baseUrl}`, status, {
      headers: new HttpHeaders().set('Content-Type', 'application/json')
    }).subscribe({
      next: () => {
        setTimeout(() => {
          window.location.reload();
          this._spinner.hide();
        }, 200);
      },
      error: () => {
        setTimeout(() => {
          this._spinner.hide();
          this._msgSvc.ShowError(this._translate.transform('failed-to-save-board'));
        }, 200);
      }
    });
  }
}
